import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import md5 from 'md5';
import { useMutation, useApolloClient } from '@apollo/client';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { getTempUserIdCookie } from 'commons/localStorage';
import { logError } from 'commons/logger';
import CtaButton from 'components/essentials/Cta/CtaButton';
import focusOnFirstFieldWithError from 'commons/focusOnFirstFieldWithError';
import { EMAIL_REGEX } from 'commons/constants';
import { getRecentlyViewed } from 'components/consumer/cart/utils';
import { LOGIN, FORGOT_PASSWORD, ADD_TO_RECENTLY_VIEWED } from 'mocks/mutations';
import { GET_CART } from 'mocks/queries';
import getZipcode from 'commons/getZipcode';
import avo from 'analytics/avo';
import { sendAnalyticsIdentifyEvent } from 'commons/analytics';
import useOpenTradeUserSidebar from 'global-state/isTradeUserSidebarOpen/useOpenTradeUserSidebar';
import useSetAuthTokenAndUser from 'data-hooks/useUserData/useSetAuthTokenAndUser';
const LoginForm = t0 => {
  const $ = _c(51);
  const {
    state,
    actions
  } = t0;
  const formRef = useRef();
  const client = useApolloClient();
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [isInvalidPassword, setIsInvalidPassword] = useState(false);
  const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
  const [, setForgotPasswordError] = useState(null);
  const [addToRecentlyViewed] = useMutation(ADD_TO_RECENTLY_VIEWED);
  const setAuthTokenAndUser = useSetAuthTokenAndUser();
  const openTradeUserSidebar = useOpenTradeUserSidebar();
  let t1;
  if ($[0] !== actions || $[1] !== addToRecentlyViewed || $[2] !== client || $[3] !== openTradeUserSidebar || $[4] !== setAuthTokenAndUser) {
    t1 = {
      onCompleted: async data => {
        if (!data.login || !data.login.user) {
          if (data.login.errors && (data.login.errors[0]?.field === "email" || data.login.errors[0]?.message?.toLowerCase()?.includes("username") || data.login.errors[0]?.message?.toLowerCase()?.includes("email"))) {
            setIsInvalidEmail(true);
          } else {
            setIsInvalidEmail(false);
          }
          if (data.login.errors && (data.login.errors[0]?.field === "password" || data.login.errors[0]?.message?.toLowerCase()?.includes("password"))) {
            setIsInvalidPassword(true);
          } else {
            setIsInvalidPassword(false);
          }
          focusOnFirstFieldWithError(formRef);
          return null;
        }
        setIsInvalidEmail(false);
        setIsInvalidPassword(false);
        const {
          access_token,
          refresh_token,
          ...user
        } = data.login.user;
        await setAuthTokenAndUser({
          access_token,
          email: user.email,
          first_name: user.first_name,
          group_id: user.group_id,
          id: user.id,
          is_designer: user.is_designer,
          is_impersonate: user.is_impersonate,
          last_name: user.last_name,
          refresh_token,
          user_discount: user.user_discount
        });
        client.query({
          query: GET_CART,
          variables: {
            zipCode: getZipcode()
          },
          fetchPolicy: "network-only"
        }).catch(_temp);
        actions.onLogin(user);
        if (actions.onClose) {
          actions.onClose();
        }
        addToRecentlyViewed({
          variables: {
            productIds: getRecentlyViewed()
          }
        });
        if (user.is_designer) {
          openTradeUserSidebar();
        }
        const analyticsUser = {
          customerId: user.id,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
          hashedEmail: user.email ? md5(user.email) : ""
        };
        sendAnalyticsIdentifyEvent(analyticsUser.customerId.toString(), {
          first_name: analyticsUser.firstName,
          last_name: analyticsUser.lastName,
          email: analyticsUser.email
        });
        avo.loggedIn({
          userId_: analyticsUser.customerId.toString(),
          firstName: analyticsUser.firstName,
          lastName: analyticsUser.lastName,
          hashedEmail: analyticsUser.hashedEmail,
          email: analyticsUser.email
        });
        return null;
      }
    };
    $[0] = actions;
    $[1] = addToRecentlyViewed;
    $[2] = client;
    $[3] = openTradeUserSidebar;
    $[4] = setAuthTokenAndUser;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const [login, t2] = useMutation(LOGIN, t1);
  const {
    loading
  } = t2;
  let t3;
  if ($[6] !== actions || $[7] !== setForgotPasswordError) {
    t3 = {
      onCompleted: data_0 => {
        if (!data_0.forgotPassword.success) {
          const rawMessage = data_0.forgotPassword.message;
          let message;
          ;
          try {
            const parsedMsg = JSON.parse(rawMessage);
            message = parsedMsg[0].message;
          } catch (t4) {
            const e = t4;
            logError(e);
            message = e.message;
          }
          setForgotPasswordError(message);
        } else {
          if (actions.onClose) {
            actions.onClose();
          }
        }
      }
    };
    $[6] = actions;
    $[7] = setForgotPasswordError;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const [forgotPassword, t4] = useMutation(FORGOT_PASSWORD, t3);
  const {
    loading: forgotPasswordLoading
  } = t4;
  let t5;
  if ($[9] !== state.email) {
    t5 = state.email?.trim() ?? "";
    $[9] = state.email;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const trimmedEmail = t5;
  let t6;
  if ($[11] !== actions || $[12] !== forgotPassword || $[13] !== state.email || $[14] !== trimmedEmail) {
    t6 = async () => {
      if (!state.email) {
        setIsInvalidPassword(true);
        return;
      }
      await forgotPassword({
        variables: {
          email: trimmedEmail
        }
      });
      actions.onForgotPasswordClick(trimmedEmail);
    };
    $[11] = actions;
    $[12] = forgotPassword;
    $[13] = state.email;
    $[14] = trimmedEmail;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const resetPassword = t6;
  let t7;
  if ($[16] !== login || $[17] !== state.password || $[18] !== state.rememberMe || $[19] !== trimmedEmail) {
    t7 = evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const tempUserId = getTempUserIdCookie();
      if (!state.password || state.password === "") {
        setIsPasswordEmpty(true);
        return false;
      }
      setIsPasswordEmpty(false);
      setIsInvalidEmail(false);
      setIsInvalidPassword(false);
      login({
        variables: {
          email: trimmedEmail,
          password: state.password,
          rememberMe: state.rememberMe,
          tempUserId
        }
      });
      return false;
    };
    $[16] = login;
    $[17] = state.password;
    $[18] = state.rememberMe;
    $[19] = trimmedEmail;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const onSubmit = t7;
  const t8 = state.showResetPassword ? "Forgot Password" : "Welcome back!";
  let t9;
  if ($[21] !== t8) {
    t9 = <div className="text-xl font-bold text-gray">{t8}</div>;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== actions) {
    t10 = evt_0 => {
      setIsInvalidEmail(false);
      actions.onEmailChange(evt_0);
    };
    $[23] = actions;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = evt_1 => {
      const isEmailValid = EMAIL_REGEX.test(String(evt_1.target.value).toLowerCase());
      setIsInvalidEmail(!isEmailValid);
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = isInvalidEmail ? "Email address is invalid" : null;
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== trimmedEmail) {
    t13 = <LabeledTextInput name="email" value={trimmedEmail} label="Email address" autoComplete="username" onChange={t10} onBlur={t11} errorMessage={t12} />;
    $[26] = t10;
    $[27] = t12;
    $[28] = trimmedEmail;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== actions.onPasswordChange || $[31] !== isInvalidPassword || $[32] !== isPasswordEmpty || $[33] !== loading || $[34] !== state.password || $[35] !== state.showResetPassword) {
    t14 = !state.showResetPassword && <><LabeledTextInput autoFocus={true} name="password" type="password" label="Password" value={state.password} autoComplete="current-password" onChange={actions.onPasswordChange} errorMessage={isPasswordEmpty ? "Password required" : isInvalidPassword ? "Incorrect password" : null} /><CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={loading} block={true} isLoading={loading}>Continue</CtaButton></>;
    $[30] = actions.onPasswordChange;
    $[31] = isInvalidPassword;
    $[32] = isPasswordEmpty;
    $[33] = loading;
    $[34] = state.password;
    $[35] = state.showResetPassword;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== onSubmit || $[38] !== t13 || $[39] !== t14) {
    t15 = <form method="POST" onSubmit={onSubmit} ref={formRef}>{t13}{t14}</form>;
    $[37] = onSubmit;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  const t16 = !!state.showResetPassword;
  const t17 = state.showResetPassword ? "black" : "brand";
  const t18 = state.showResetPassword ? "solid-button" : "link";
  let t19;
  if ($[41] !== forgotPasswordLoading || $[42] !== resetPassword || $[43] !== t16 || $[44] !== t17 || $[45] !== t18) {
    t19 = <div className="mt-4 text-center"><CtaButton size="sm" hasArrow={false} onClick={resetPassword} disabled={forgotPasswordLoading} block={t16} color={t17} styling={t18} isLoading={forgotPasswordLoading}>Reset Password</CtaButton></div>;
    $[41] = forgotPasswordLoading;
    $[42] = resetPassword;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t15 || $[48] !== t19 || $[49] !== t9) {
    t20 = <div className="text-gray"><div className="consumer-login-form__content">{t9}{t15}{t19}</div></div>;
    $[47] = t15;
    $[48] = t19;
    $[49] = t9;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
};
LoginForm.propTypes = {
  state: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    rememberMe: PropTypes.bool,
    showResetPassword: PropTypes.bool
  }),
  actions: PropTypes.shape({
    onEmailChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
    onRememberMeChange: PropTypes.func,
    onForgotPasswordClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogin: PropTypes.func
  })
};
export default LoginForm;
function _temp(err) {
  logError(err, "Failed to fetch cart on login");
}